const childRoutes = prop => [
    {
        path: 'dashboard',
        name: prop + '.dashboard',
        meta: { auth: true },
        component: () => import('../pages/dashboard/List.vue')
    },
    {
        path: 'create-campaign',
        name: prop + '.create_campaign',
        meta: { auth: true },
        component: () => import('../pages/create-campaign/List.vue')
    },
    {
        path: 'assessment-add',
        name: prop + '.assessment_add',
        meta: { auth: true },
        component: () => import('../pages/consultancy-management/AssessmentAddMain.vue')
    },
    {
        path: 'mtv-assessment-add',
        name: prop + '.mtv_assessment_add',
        meta: { auth: true },
        component: () => import('../pages/mtv-consultancy-management/AssessmentAddMain.vue')
    },
    {
        path: 'assessment-add-ot',
        name: prop + '.assessment_add_ot',
        meta: { auth: true },
        component: () => import('../pages/consultancy-management-ot/AssessmentAddMain.vue')
    },
    {
        path: 'mtv-assessment-add-ot',
        name: prop + '.mtv_assessment_add_ot',
        meta: { auth: true },
        component: () => import('../pages/mtv-consultancy-management-ot/AssessmentAddMain.vue')
    },
    {
        path: 'assessment-add-slt',
        name: prop + '.assessment_add_slt',
        meta: { auth: true },
        component: () => import('../pages/consultancy-management-slt/AssessmentAddMain.vue')
    },
    {
        path: 'mtv-assessment-add-slt',
        name: prop + '.mtv_assessment_add_slt',
        meta: { auth: true },
        component: () => import('../pages/mtv-consultancy-management-slt/AssessmentAddMain.vue')
    },
    // {
    //     path: 'mtv-assessment-add',
    //     name: prop + '.mtv_assessment_add',
    //     meta: { auth: true },
    //     component: () => import('../pages/mtv-consultancy-management/AssessmentAddMain.vue')
    // },
    {
        path: 'assign-campaign-user',
        name: prop + '.assign_campaign_user',
        meta: { auth: true },
        component: () => import('../pages/assign-campaign-user/List.vue')
    },
    {
        path: 'administrative-info',
        name: prop + '.administrative_info',
        meta: { auth: true },
        component: () => import('../pages/administrative-info/List.vue')
    },
    {
        path: 'mtv-daily-service',
        name: prop + '.mtv_patient_registration',
        meta: { auth: true },
        component: () => import('../pages/mtv-daily-service/List.vue')
    },
    {
        path: 'mtv-daily-service-entry',
        name: prop + '.mtv_patient_registration',
        meta: { auth: true },
        component: () => import('../pages/mtv-daily-service/Form.vue')
    },
    {
        path: 'mtv-patient-registration',
        name: prop + '.mtv_patient_registration',
        meta: { auth: true },
        component: () => import('../pages/mtv-patient-registration/List.vue')
    },
    {
        path: 'mtv-add-patient',
        name: prop + '.mtv_patient_registration',
        meta: { auth: true },
        component: () => import('../pages/mtv-patient-registration/Form.vue')
    },
    {
        path: 'mtv-patient-registration-details',
        name: prop + '.mtv_patient_registration_details',
        meta: { auth: true },
        component: () => import('../pages/mtv-patient-registration/ViewForm.vue')
    },
    {
        path: 'mtv-application-list',
        name: prop + '.mtv_application_list',
        meta: { auth: true },
        component: () => import('../pages/mtv-patient-registration/List.vue')
    },
    {
        path: 'mtv-consultancy-management',
        name: prop + '.mtv_consultancy_management',
        meta: { auth: true },
        component: () => import('../pages/mtv-therapy-management/List.vue')
    },
    {
        path: 'mtv-therapy-management',
        name: prop + '.mtv_therapy_management',
        meta: { auth: true },
        component: () => import('../pages/mtv-therapy-management/List.vue')
    },
    {
        path: 'mtv-yearly-campaign',
        name: prop + '.mtv_yearly_campaign',
        meta: { auth: true },
        component: () => import('../pages/mtv-yearly-campaign/List.vue')
    },
    {
        path: 'mtv-yearly-campaign-form',
        name: prop + '.mtv_yearly_campaign',
        meta: { auth: true },
        component: () => import('../pages/mtv-yearly-campaign/Form.vue')
    },
    {
        path: 'mtv-yearly-campaign-form/?:id',
        name: prop + '.mtv_yearly_campaign',
        meta: { auth: true },
        component: () => import('../pages/mtv-yearly-campaign/Form.vue')
    },
    {
        path: 'mtv-monthly-campaign',
        name: prop + '.mtv_monthly_campaign',
        meta: { auth: true },
        component: () => import('../pages/mtv-monthly-campaign/List.vue')
    },
    {
        path: 'mtv-monthly-campaign-form',
        name: prop + '.mtv_monthly_campaign',
        meta: { auth: true },
        component: () => import('../pages/mtv-monthly-campaign/Form.vue')
    },
    {
        path: 'mtv-monthly-campaign-form/?:id',
        name: prop + '.mtv_monthly_campaign',
        meta: { auth: true },
        component: () => import('../pages/mtv-monthly-campaign/Form.vue')
    },
    {
        path: 'patient-registration-all',
        name: prop + '.patient_registration',
        meta: { auth: true },
        component: () => import('../pages/patient-registration/CommonPrList.vue')
    },
    {
        path: 'patient-registration',
        name: prop + '.patient_registration',
        meta: { auth: true },
        component: () => import('../pages/patient-registration/List.vue')
    },
    {
        path: 'add-patient',
        name: prop + '.patient_registration',
        meta: { auth: true },
        component: () => import('../pages/patient-registration/Form.vue')
    },
    {
        path: 'patient-registration-details',
        name: prop + '.patient_registration_details',
        meta: { auth: true },
        component: () => import('../pages/patient-registration/ViewForm.vue')
    },
    {
        path: 'new-registration-list',
        name: prop + '.new_registration_list',
        meta: { auth: true },
        component: () => import('../pages/new-registration-list/List.vue')
    },
    {
        path: 'application-list',
        name: prop + '.application_list',
        meta: { auth: true },
        component: () => import('../pages/patient-registration/List.vue')
    },
    {
        path: 'consultancy-management',
        name: prop + '.consultancy_management',
        meta: { auth: true },
        component: () => import('../pages/therapy-management/List.vue')
    },
    {
        path: 'revisit-prescription',
        name: prop + '.revisit_prescription',
        meta: { auth: true },
        component: () => import('../pages/revisit-prescription/List.vue')
    },
    {
        path: 'follow-up-chart',
        name: prop + '.follow_up_chart',
        meta: { auth: true },
        component: () => import('../pages/follow-up-chart/List.vue')
    },
    {
        path: 'add-patient-form',
        name: prop + '.patient_registration_form',
        meta: { auth: true },
        component: () => import('../pages/follow-up-chart/Form.vue')
    },
    {
        path: 'mtv-follow-up-chart',
        name: prop + '.mtv_follow_up_chart',
        meta: { auth: true },
        component: () => import('../pages/mtv-follow-up-chart/List.vue')
    },
    {
        path: 'add-mtv-patient-form',
        name: prop + '.mtv_patient_registration_form',
        meta: { auth: true },
        component: () => import('../pages/mtv-follow-up-chart/Form.vue')
    },
    {
        path: 'therapy-management',
        name: prop + '.therapy_management',
        meta: { auth: true },
        component: () => import('../pages/therapy-management/List.vue')
    },
    {
        path: 'therapy-prescription-add',
        name: prop + '.therapy_prescription_add',
        meta: { auth: true },
        component: () => import('../pages/therapy-management/Formx.vue')
    },
    {
        path: 'mtv-therapy-prescription-add',
        name: prop + '.mtv_therapy_prescription_add',
        meta: { auth: true },
        component: () => import('../pages/mtv-therapy-management/Form.vue')
    },
    {
        path: 'patient-registration-number-wise-view',
        name: prop + '.patient_registration_details_view',
        meta: { auth: true },
        component: () => import('../pages/reports/patient-number-wise-report/PatView.vue')
    },
    {
        path: 'patient-registration-number-wise-details-view',
        name: prop + '.patient_registration_details_view',
        meta: { auth: true },
        component: () => import('../pages/patient-registration-details-view/ViewPatientNumberWiseHistory.vue')
    },
    {
        path: 'add-service-center',
        name: prop + '.add_service_center',
        meta: { auth: true },
        component: () => import('../pages/add-service-center/List.vue')
    },
    {
        path: 'reports',
        name: prop + '.reports',
        meta: { auth: true },
        component: () => import('../pages/reports/List.vue')
    },
    {
        path: 'center-wise-report',
        name: prop + '.center_wise_report',
        meta: { auth: true },
        component: () => import('../pages/reports/center-wise-report/List.vue')
    },
    {
        path: 'mtv-administrative-report',
        name: prop + '.mtv_administrative_report',
        meta: { auth: true },
        component: () => import('../pages/reports/mtv-administrative-report/List.vue')
    },
    {
        path: 'monthly-therapy-service-report',
        name: prop + '.monthly_therapy_service_report',
        meta: { auth: true },
        component: () => import('../pages/reports/monthly-therapy-service-report/List.vue')
    },
    {
        path: 'new-patient-disability-wise-report',
        name: prop + '.new_patient_disability_wise_report',
        meta: { auth: true },
        component: () => import('../pages/reports/new-patient-disability-wise-report/List.vue')
    },
    {
        path: 'monthly-disability-report',
        name: prop + '.monthly_disability_report',
        meta: { auth: true },
        component: () => import('../pages/reports/monthly-disability-report/List.vue')
    },
    {
        path: 'disability-type-wise-patient-number-report',
        name: prop + '.disability_type_wise_patient_number_report',
        meta: { auth: true },
        component: () => import('../pages/reports/disability-type-wise-patient-number-report/List.vue')
    },
    {
        path: 'yearly-registered-report',
        name: prop + '.yearly_registered_report',
        meta: { auth: true },
        component: () => import('../pages/reports/yearly-registered-report/List.vue')
    },
    {
        path: 'yearly-patient-number-wise-report',
        name: prop + '.yearly_patient_number_wise_report',
        meta: { auth: true },
        component: () => import('../pages/reports/yearly-patient-number-wise-report/List.vue')
    },
    {
        path: 'yearly-service-delivered-report',
        name: prop + '.yearly_service_delivered_report',
        meta: { auth: true },
        component: () => import('../pages/reports/yearly-service-delivered-report/List.vue')
    },
    {
        path: 'yearly-service-number-wise-report',
        name: prop + '.yearly_service_number_wise_report',
        meta: { auth: true },
        component: () => import('../pages/reports/yearly-service-number-wise-report/List.vue')
    },
    {
        path: 'center-wise-reports',
        name: prop + '.center_wise_reports',
        meta: { auth: true },
        component: () => import('../pages/reports/center-wise-reports/List.vue')
    },
    {
        path: 'performance-patient-report',
        name: prop + '.performance_patient_report',
        meta: { auth: true },
        component: () => import('../pages/reports/performance-patient-report/List.vue')
    },
    {
        path: 'new-patient-performance-report',
        name: prop + '.new_patient_performance__report',
        meta: { auth: true },
        component: () => import('../pages/reports/new-patient-performance-report/List.vue')
    },
    {
        path: 'service-performance-report',
        name: prop + '.service_performance_report',
        meta: { auth: true },
        component: () => import('../pages/reports/service-performance-report/List.vue')
    },
    {
        path: 'driver-info-report',
        name: prop + '.driver_info_report',
        meta: { auth: true },
        component: () => import('../pages/reports/driver-info-report/List.vue')
    },
    {
        path: 'therapeutic-device-info',
        name: prop + '.device_info',
        meta: { auth: true },
        component: () => import('../pages/device-info/List.vue')
    },
    {
        path: 'therapeutic-device-info-form',
        name: prop + '.device_info_form',
        meta: { auth: true },
        component: () => import('../pages/device-info/Form.vue')
    },
    {
        path: 'therapeutic-device-info-form/:id',
        name: prop + '.device_info_form_edit',
        meta: { auth: true },
        component: () => import('../pages/device-info/Form.vue')
    },
    {
        path: 'therapeutic-device-info-it',
        name: prop + '.device_info_it',
        meta: { auth: true },
        component: () => import('../pages/device-info/ListInfo.vue')
    },
    {
        path: 'therapeutic-device-info-form-it',
        name: prop + '.device_info_form_it',
        meta: { auth: true },
        component: () => import('../pages/device-info/FormInfo.vue')
    },
    {
        path: 'therapeutic-device-info-form-it/:id',
        name: prop + '.device_info_form_edit_it',
        meta: { auth: true },
        component: () => import('../pages/device-info/FormInfo.vue')
    },
    {
        path: 'patient-number-wise-report',
        name: prop + '.patient-number-wise-report',
        meta: { auth: true },
        component: () => import('../pages/reports/patient-number-wise-report/List.vue')
    },
    {
        path: 'new-patient-number-wise-report',
        name: prop + '.new-patient-number-wise-report',
        meta: { auth: true },
        component: () => import('../pages/reports/new-patient-number-wise-report/List.vue')
    },
    {
        path: 'new-patient-number-wise-report-view',
        name: prop + '.new-patient-number-wise-report-view',
        meta: { auth: true },
        component: () => import('../pages/reports/new-patient-number-wise-report/PatView.vue')
    },
    {
        path: 'service-number-wise-report',
        name: prop + '.service-number-wise-report',
        meta: { auth: true },
        component: () => import('../pages/reports/service-number-wise-report/List.vue')
    },
    {
        path: 'mtv-monthly-service-report',
        name: prop + '.mtv_monthly_service_report',
        meta: { auth: true },
        component: () => import('../pages/reports/mtv-monthly-service-report/List.vue')
    },
    {
        path: 'mtv-daily-service-report',
        name: prop + '.mtv_daily_service_report',
        meta: { auth: true },
        component: () => import('../pages/reports/mtv-daily-service-report/List.vue')
    },
    {
        path: 'mtv-monitoring-report',
        name: prop + '.mtv_monitoring_report',
        meta: { auth: true },
        component: () => import('../pages/reports/mtv-monitoring-report/List.vue')
    },
    {
        path: 'configuration/assistive-device',
        name: prop + '.assistive_device',
        meta: { auth: true },
        component: () => import('../pages/configuration/assistive-device/List.vue')
    },
    {
        path: 'configuration/report-heading',
        name: prop + '.report_heading',
        meta: { auth: true },
        component: () => import('../pages/configuration/report-heading/List.vue')
    },
    {
        path: 'configuration/equipment-info-second',
        name: prop + '.equipment_info_second',
        meta: { auth: true },
        component: () => import('../pages/configuration/equipment-info/List.vue')
    },
    {
        path: 'configuration/equipment-info',
        name: prop + '.equipment_info',
        meta: { auth: true },
        component: () => import('../pages/configuration/equipment-info/List.vue')
    },
    {
        path: 'equipment-report',
        name: prop + '.equipment_report',
        meta: { auth: true },
        component: () => import('../pages/reports/equipment-report/List.vue')
    },
    {
        path: 'configuration/equipment-spec',
        name: prop + '.equipment_spec',
        meta: { auth: true },
        component: () => import('../pages/configuration/equipment-spec/List.vue')
    },
    {
        path: 'configuration/center-customize',
        name: prop + '.center_customize',
        meta: { auth: true },
        component: () => import('../pages/configuration/center-customize/List.vue')
    },
    {
        path: 'configuration/cc',
        name: prop + '.cc',
        meta: { auth: true },
        component: () => import('../pages/configuration/cc/List.vue')
    },
    {
        path: 'configuration/import-patient',
        name: prop + '.import_patient',
        meta: { auth: true },
        component: () => import('../pages/configuration/import-patient/List.vue')
    },
    {
        path: 'configuration/hpc',
        name: prop + '.hpc',
        meta: { auth: true },
        component: () => import('../pages/configuration/hpc/List.vue')
    },
    {
        path: 'configuration/rx',
        name: prop + '.rx',
        meta: { auth: true },
        component: () => import('../pages/configuration/rx/List.vue')
    },
    {
        path: 'configuration/dh',
        name: prop + '.dh',
        meta: { auth: true },
        component: () => import('../pages/configuration/dh/List.vue')
    },
    {
        path: 'configuration/oe',
        name: prop + '.oe',
        meta: { auth: true },
        component: () => import('../pages/configuration/oe/List.vue')
    },
    {
        path: 'configuration/pmh',
        name: prop + '.pmh',
        meta: { auth: true },
        component: () => import('../pages/configuration/pmh/List.vue')
    },
    {
        path: 'configuration/advice',
        name: prop + '.advice',
        meta: { auth: true },
        component: () => import('../pages/configuration/advice/List.vue')
    },
    {
        path: 'configuration/diagnosis',
        name: prop + '.diagnosis',
        meta: { auth: true },
        component: () => import('../pages/configuration/diagnosis/List.vue')
    }
]
const routes = [
    {
        path: '/hospital-disability-service/consultancy-therapy-center',
        name: 'hospital_disability_service.consultancy_therapy_center',
        component: () => import('@/layouts/HospitalDisabilityService.vue'),
        meta: { auth: true },
        children: childRoutes('hospital_disability_service.consultancy-therapy-center')
    }
]

export default routes
